export default {
  //login page
  tagline: "Smart work starts here.",
  subtext: "Log in to optimize your field operations.",
  emailLabel: "Email",
  passwordLabel: "Password",
  emailPlaceholder: "Email",
  passwordPlaceholder: "Password",
  forgotPassword: "Forgot Password?",
  forgotPasswordTip: "No worries! Enter your email to securely reset your password.",
  signIn: "Sign In",
  copyrightText: "Copyright Field Force",
  returnToLogin: "Return to Login",
  enterOTPAndResetPassword: "Enter the 6-digit OTP sent to your email and create a unique, strong password.",

  //sidebar
  dashboard: "Dashboard",
  analytics: "Analytics",
  forms: "Forms",
  logout: "Logout",

  //task and its sub menus
  task: "Task",
  taskList: "Task List",
  planner: "Planner",
  locate: "Locate Team",
  taskTarget: "Task Target",
  archiveTask: "Archived Task",

  //manage and its sub menu
  manage: "Manage",
  visitProfile: "Visit Profile",
  employee: "Employee",
  permissions: "Permissions",
  status: "Status",
  searchHere: "Search here....",
  permissionGroup: "Permission Group",
  officeLocation: "Office Location",
  team: "Team",
  product: "Product",
  designation: "Designation",
  designationLevel: "Designation Level",
  doctor: "Doctor",
  department: "Department",
  doctorSpecialization: "Doctor Specialization",
  doctorDesignation: "Doctor Designation",
  practiceLocation: "Practice Location",
  practiceLocationType: "Practice Location Type",
  locationType: "Location Type",
  employmentStatus: "Employment Status",
  customerRank: "Customer Rank",
  subTask: "Sub Task",
  taskStatus: "Task Status",
  taskType: "Task Type",
  taskPriority: "Task Priority",
  city: "City",
  country: "Country",
  role: "Role",
  specialization: "Specialization",
  getOTP: "Get OTP",

  //components
  downloadSummary: "Download Summary",
  addTask: "Add Task",
  viewNotes: "View Notes",
  taskDetails: "Task Details",
  addNew: "Add New",
  filters: "Filters",
  hide: "Hide",
  search: "Search",
  of: "of",
  visitDate: "Visit Date",
  accompaniedBy: "Accompanied By (Optional)",
  assignTo: "Assign To",
  assignedTo: "Assigned To",
  assignedBy: "Assigned By",
  assignToMe: "Assign To Me",
  name: "Name",
  shortName: "Short Name",
  firstName: "First Name",
  lastName: "Last Name",
  doctorName: "Doctor Name",
  personalContact: "Personal Contact",
  contact: "Contact Number",
  dateOfJoining: "Date of Joining",
  cnicNo: "CNIC Number",
  gender: "Gender",
  passportNo: "Passport Number",
  personalEmail: "Personal Email",
  address: "Address",
  headOffice: "Head Office",
  displayName: "Display Name",
  createdOn: "Created On",
  reportsTo: "Reports To",
  officialDetails: "Official Details",
  description: "Description",
  active: "Active?",
  save: "Save",
  cancel: "Cancel",
  addAnother: "Add Another",
  addDoctor: "Add Doctor",
  submitPlan: "Submit Plan",
  myPlan: "My Plan",
  month: "Month",
  week: "Week",
  day: "Day",
  selectEmployee: "Select Employee",
  personalDetails: "Personal Details",
  addEmployee: "Add Employee",
  clearAll: "Clear All",
  myTasks: "My Tasks",
  subOrdinates: "Subordinates",
  newPassword: "New Password",
  confirmPassword: "Confirm Password",
  emailNotReceivedTip: "If you don't receive the email within 5 minutes, check the spam folder.",
  resendOTP: "Resend OTP",
  tryAgain: "Try Again",
  or: "Or",
  submit: "Submit",
  noDataFound: "No Data Found",
  onLeave: "On Leave",
  enterLeaveMessage: "Enter your leave message here",
  leaveMessage: "Leave Message",
  visitTime: "Visit Time",
  start: "Start",
  end: "End",
  callAverage: "Call Average",
  callAverageByTable: "Call Average by Table",
  callAverageByEmployee: "Call Average by Employee",
  callAverageByProduct: "Call Average by Product",
  callAverageByPracticeLocation: "Call Average by Practice Location",
  kol: "KOL",
  activeEmployee: "Active Employee",
  totalDoctors: "Total Doctors",
  visitProfiles: "Visit Profiles",
  practiceLocations: "Practice Locations",
  createdBy: "Created By",
  lastLogin: "Last Login",
  lastUpdated: "Last Updated",
  action: "Action",
  title: "Title",

  //add actions
  addVisitProfile: "Add Visit Profile",
  addPermissionGroup: "Add Permission Group",
  addPermissionGroupTip: "Define access level and permissions",
  addOfficeLocation: "Add Office Location",
  addOfficeLocationTip: "Enter details of company office location",
  addTeam: "Add Team",
  addTeamTip: "Create teams to manage users and improve collaboration",
  addProduct: "Add Product",
  addProductTip: "Enter product information and related documents",
  addDesignation: "Add Designation",
  addDesignationTip: "Assign and manage job positions in the organization",
  addDepartment: "Add Department",
  addDepartmentTip: "Create a new department and manage team assignments",
  addDoctorDesignation: "Add Doctor Designation",
  addDoctorDesignationTip: "Add a new designation for doctors",
  addDoctorSpecialization: "Add Doctor Specialization",
  addDoctorSpecializationTip: "Assign new specialization for doctors",
  addPracticeLocation: "Add Practice Location",
  addPracticeLocationTip: "Add new practice location",
  addCustomerRank: "Add Customer Rank",
  addCustomerRankTip: "Assign a rank for customer classification",
  addSubTasks: "Add Sub Tasks",
  addSubTasksTip: "Create a small, manageable task within a larger task",
  addCity: "Add City",
  addCityTip: "Enter a city below",
  addRole: "Add Role",
  addRoleTip: "Define role and related permission group",
  addEmploymentStatus: "Add Employment Status",
  addEmploymentStatusTip: "Define employment status",
  addTaskPriority: "Add Task Priority",
  addTaskPriorityTip: "Set urgent level to prioritize task completion",
  pastePlan: "Paste Plan",
  pastePlanTip: "These are your copied dates. Click on target date to modify if needed",
  paste: "Paste",
  pasteMonthlyPlanConfirm: "You are about to paste a monthly plan. This will override already added visits for this month. Continue?",
  addItem: "Add new {{item}}",
  createNewItemRecord: "Create new {{item}} record",
  jobLocation: "Job Location",
  officialEmail: "Official Email",
  officialContact: "Official Contact",
  employeeId: "Employee ID",
  applyFilters: "Apply Filters",
  select: "Select",
  from: "From",
  to: "To",
  noDataMessage: "No data to show. 'Apply or change Filters'",
  custom: "Custom",
  apply: "Apply",
  reset: "Reset",
  date: "Date",
  calls: "Calls",
  notes: "Notes",
  enterTaskNote: "Enter Task Note",
  taskNote: "Task Note",
  addNote: "Add Note",
  attachments: "Attachments",
  statusHistory: "Status History",
  add: "Add",
  type: "Type",
  levelOrder: "Level Order",
  addDesignationLevel: "Add Designation Level",
  addDesignationLevelTip: "This will define the level of a designation in hierarchy",
  lowerNumberHierarchyTip: "Lower numbers indicate higher levels in the hierarchy.",
  color: "Color",
  addCities: "Add City",
  addCitiesTip: "Enter a City below.",
  attachedDocuments: "Attached Documents",
  noFilesAttached: "No files attached",
  clickToUpload: "Click to Upload",
  acceptedFormats: "Accepted Formats",
  viewDetails: "View Details",

  total: "Total",
  created: "Created",
  inReview: "In-Review",
  approved: "Approved",
  inProgress: "In-Progress",
  rejected: "Rejected",
  cancelled: "Cancelled",
  onHold: "On-Hold",
  reScheduled: "Re-Scheduled",
  completed: "Completed",
  doctorUnavailable: "Doctor-Unavailable",
  refusedToMeet: "Refused-To-Meet",
  visitComplete: "Visit-Complete",
  submitted: "Submitted",
  submitPlan: "Submit Plan",
  submitPlanTip: "You will not be able to make changes after submission. Are you sure you want to continue?",
  approvePlan: "Approve Plan",
  approvePlanTip: "Are you sure you want to approve this monthly plan? Your decision will finalize the review for this employee.",
  rejectPlan: "Reject Plan",
  rejectPlanTip: "Are you sure you want to reject this monthly plan? The employee will need to review and resubmit the plan for approval.",
  approve: "Approve",
  addSuggestionsHere: "Add suggestions here",
  noRejectionNotes: "No rejection notes available",
  rejectionNotes: "Rejection Notes",
  time: "Time",

  update: "Update",
  map: "Map",
  chooseLocation: "Choose Location",
  loadingMap: "Loading Map",
  displayAddress: "Display Address",
  enterDisplayAddress: "Enter display address",

  // Travel Summary
  travelSummary: "Travel Summary",
  totalDistance: "Total Distance",
  totalFuelCost: "Total Fuel Cost",
  fuelRate: "Fuel Rate",
  vehicleAverage: "Vehicle Average",
  edit: "Edit",
  editFuelRate: "Edit Fuel Rate",
  editVehicleAverage: "Edit Vehicle Average",
  pricePerLiter: "Price per liter",
  averageKmPerLiter: "Average (km/L)",
  distance: "Distance",
  fuel: "Fuel",
  input: "Input",
  invalidFuelRate: "Please enter a valid fuel rate greater than 0",
  invalidVehicleAverage: "Please enter a valid vehicle average greater than 0",
  viewSubordinates: "View Subordinates",
  allSubordinates: "All Subordinates",
  
};
